export default {
    getToken() {
        return window.localStorage.getItem('jwtToken');
    },

    setToken(token) {
        return window.localStorage.setItem('jwtToken', token);
    },

    clearToken() {
        return window.localStorage.removeItem('jwtToken');
    }
}